import Button from "@shared/v2/Button";
import { useTheme } from "../../reducers/layoutReducer/selectors";

const ReferAFriend = () => {
  const isPlace = useTheme().name === "place-theme";
  return (
    <Button
      className={`tw-mr-[4px] bs-xs:tw-hidden ${isPlace ? "!tw-border-white" : ""}`}
      onClick={() => window.location.assign("/agent_stats?report_tab=referrals")}
    >
      Refer<span className="bs-sm:tw-hidden"> A Friend</span>
    </Button>
  );
};

export default ReferAFriend;
